(function () {

    'use strict';

    angular.module('FotocApp')

        .component('tutoUserAction', {

            templateUrl: (USE_TEMPLATE_CACHE ? '' : window.BASE_PATH) + 'editor/tutorial/tutoUserAction.component.html',
            bindings: {},
            controller: ['$scope', '$tutorialService', '$editorService', '$canvasService', '$lang', '$window', 'CONSTANTS', function ($scope, $tutorialService, $editorService, $canvasService, $lang, $window, CONSTANTS) {

                var self = this;

                this.$tutorialService = $tutorialService;
                this.$editorService = $editorService;
                $scope.$lang = $lang;

                this.images = [
                    { o: CONSTANTS.WEB_PATH + 'img/tutoriales/user/0.jpg', t: CONSTANTS.WEB_PATH + 'img/tutoriales/user/0_t.jpg' },
                    { o: CONSTANTS.WEB_PATH + 'img/tutoriales/user/1.jpg', t: CONSTANTS.WEB_PATH + 'img/tutoriales/user/1_t.jpg' },
                    { o: CONSTANTS.WEB_PATH + 'img/tutoriales/user/2.jpg', t: CONSTANTS.WEB_PATH + 'img/tutoriales/user/2_t.jpg' }
                ]

                this.$onInit = function () {

                };

                this.upload = function () {

                    if (window.browserInfo !== undefined && window.browserInfo.mobile) {
                        if (window.browserInfo.os === 'ios') {
                            if (window.browserInfo.browser === 'facebook') {
                                return $tutorialService.showSlideOSFacebook();
                            } else if (window.browserInfo.browser === 'instagram') {
                                return $tutorialService.showSlideOSInstagram();
                            }
                        } else if (window.browserInfo.os === 'android') {
                            if (window.browserInfo.browser === 'facebook') {
                                return $tutorialService.showSlideAndroidFacebook();
                            } else if (window.browserInfo.browser === 'instagram') {
                                return $tutorialService.showSlideAndroidInstagram();
                            }
                        }
                    }
                    $editorService.openModalUploadCarteFunct();
                    $tutorialService.close();
                };


                this.selectImage = function ($index) {

                    var json_item_mygalery = {

                        fotocOwner: true,
                        uuid: 'foto-user-' + $index,
                        cdnUrl: this.images[$index].o,
                        originalUrl: this.images[$index].o,
                        originalImageInfo: {
                            width: 800,
                            height: 533
                        }

                    }

                    $tutorialService.close()

                    if (!$editorService.ui.compositionsAsGroup) {
                        $editorService.data.images[$editorService.ui.editingItem] = {
                            type: 'my_galery',
                            data: json_item_mygalery,
                            frameColor: $editorService.ui.lastFrameColorSelected,
                            urlWithoutFilter: this.images[$index].o,
                            position: {}
                        }
                        $canvasService.setImage(this.images[$index].o)
                        $editorService.setCacheImages(this.images[$index].o);
                    }

                    if ($editorService.ui.my_galery.indexOf(json_item_mygalery) === -1) {
                        $editorService.ui.my_galery.push(json_item_mygalery)
                    }

                    if ($editorService.ui.compositionsAsGroup) {
                        $editorService.data.images.push({
                            type: 'my_galery',
                            data: json_item_mygalery,
                            frameColor: $editorService.ui.lastFrameColorSelected,
                            urlWithoutFilter: this.images[$index].o,
                            urlWithFilter: this.images[$index].o,
                            position: {}
                        });
                    }
                }
            }]
        })
})();